import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Radio, ArrowRight, CheckCircle2, FileText } from "lucide-react";

export function StudioLanding() {
  const navigate = useNavigate();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data: projects } = await api.get("/projects");
        const withMs = await Promise.all(projects.map(async (p) => {
          try { const { data } = await api.get(`/projects/${p.id}/manuscript`); return { ...p, manuscript: data.active }; }
          catch { return { ...p, manuscript: null }; }
        }));
        setRows(withMs);
      } catch { setRows([]); }
    })();
  }, []);
  return (
    <div>
      <div className="mb-2 font-mono text-[11px] uppercase tracking-[0.25em] text-amber-500/70">Phase 8 · Studio Sync</div>
      <h1 className="font-serif text-4xl tracking-tight text-slate-100">ElevenLabs Studio</h1>
      <p className="mt-2 text-sm text-slate-400">Push the approved production (chapters · Scott · dictionary) into a linked ElevenLabs Studio project. Push-only — the app stays the system of record.</p>
      {rows === null ? (
        <div className="flex items-center justify-center py-24"><Loader2 className="h-6 w-6 animate-spin text-amber-500" /></div>
      ) : rows.length === 0 ? (
        <div className="mt-10 rounded-xl border border-dashed border-border bg-[#12161f]/40 py-24 text-center text-slate-400">Import a manuscript first.</div>
      ) : (
        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {rows.map((p) => (
            <button key={p.id} data-testid={`studio-project-${p.id}`} onClick={() => navigate(`/studio/projects/${p.id}/studio`)}
              className="group flex items-center justify-between rounded-xl border border-border bg-[#12161f] p-5 text-left transition-all hover:border-amber-500/40">
              <div>
                <h3 className="font-serif text-xl text-slate-100">{p.title}</h3>
                {p.manuscript ? (
                  <p className="mt-1 flex items-center gap-1.5 text-xs text-emerald-400"><CheckCircle2 className="h-3.5 w-3.5" />{p.manuscript.word_count.toLocaleString()} words · v{p.manuscript.version_number}</p>
                ) : (<p className="mt-1 flex items-center gap-1.5 text-xs text-slate-500"><FileText className="h-3.5 w-3.5" /> No manuscript</p>)}
              </div>
              <div className="flex items-center gap-2 text-slate-600 group-hover:text-amber-400"><Radio className="h-4 w-4" /><ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
